import type { EntityMetadata } from '@web-config-app/core';
import { useEntityData } from '../use-entity-data/use-entity-data';

const defaultEntityMetadata: EntityMetadata = { status: 'new' };

export const useEntityMetadata = (): EntityMetadata => {
  const entityData = useEntityData();
  return entityData?.attributes?.entityMetadata ?? defaultEntityMetadata;
};
